export enum ContentTypeEnum {
  Text = 'Text',
  Image = 'Image',
  Markdown = 'Markdown',
  Html = 'Html',
}
